import React from 'react'
import './about.css';

import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi';
import {VscFolderLibrary} from 'react-icons/vsc'
import MeAbout from '../../assets/me-abt.png';

const About = () => {
  return (
	<section id="about">
    <h5>Get To Know</h5>
    <h2>About Me</h2>

    <div className="container about__container">
      <div className="about__me">
        <div className="about__me-image">
          <img src={MeAbout} alt="About Image" />
        </div>
      </div>
      <div className="about__content">
        <div className="about__cards">
          <article className="about__card">
            <FaAward className="about__icon"/>
            <h5>Experience</h5>
            <small>3+ Years Working</small>
          </article>
          <article className="about__card">
            <FiUsers className="about__icon"/>
            <h5>Interests</h5>
            <small>Tennis & Anime</small>
          </article>
          <article className="about__card">
            <VscFolderLibrary className="about__icon"/>
            <h5>Projects</h5>
            <small>10+ Completed Projects</small>
          </article>
        </div>

        <p>
          Hi all, I am currently a student at New Jersey Institute of Technology pursuing a bachelors in Computer Science. I am really interested in full stack Development, but
          primarily focused on backend. However, I am decentally skilled at frontend framework such as React and Angular. In my free time, I like to play tennis and watch anime, along with go on nature walks.
        </p>

        <a href="#contact" className="btn btn-primary"> Let's Talk</a>
      </div>

    </div>
  </section>
  )
}

export default About;